import React, { useEffect } from 'react';
import { IoCloseOutline } from 'react-icons/io5';
import VideoPlayer from './VideoPlayer';
import { reloadIfLinksExpired } from '../utils/expiredLinks';

function MediaPreview({ open, url, fileType, qualityTypeArray, poster, autoPlay = false, onClose, onPlay }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  const isVideo = String(fileType) === '2';

  return (
    <div className="modal-video">
      <button
        onClick={onClose}
        style={{
          position: 'fixed', top: 16, right: 16, zIndex: 9999,
          width: 36, height: 36, borderRadius: '50%',
          background: 'rgba(0,0,0,0.6)', border: 'none', cursor: 'pointer',
          color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}
      >
        <IoCloseOutline size={22} />
      </button>
      {isVideo ? (
        <VideoPlayer
          qualityTypeArray={qualityTypeArray}
          url={url}
          poster={poster}
          autoPlay={autoPlay}
          onPlay={onPlay}
          onContextMenu={(e) => e.preventDefault()}
        />
      ) : (
        <img
          src={url}
          className="media-fit media-no-save"
          draggable={false}
          alt="preview"
          onError={() => reloadIfLinksExpired(url)}
          onContextMenu={(e) => e.preventDefault()}
        />
      )}
    </div>
  );
}

export default MediaPreview;
